import React, { useState, useEffect } from 'react';
import './ManageUsers.css'
import AuthService from './auth/AuthServices';

const ManageLicences = () => {
  const [adminKey, setAdminKey] = useState('')
  const [isDemo, setIsDemo] = useState('')
  const [selectedSubsUUID, setSelectedSubsUUID] = useState('')
  const [newLicenseKey, setNewLicenseKey] = useState('')
  const [isAddLicenseOpen, setIsAddLicenseOpen] = useState(false)
  const [subscriptions, setSubscriptions] = useState({})
  const [licenseTypes, setLicenseTypes] = useState({})
  const [allLicenseData, setAllLicenseData] = useState('')
  const [allLicenseDataCurrentPage, setAllLicenseDataCurrentPage] = useState(1)
  const [allLicenseDataTotalPages, setAllLicenseDataTotalPages] = useState(1)
  const [selectedLicenseTypeUUID, setSelectedLicenseTypeUUID] = useState('')
  const [handleDeletePopup, setHandleDeletePopup] = useState(false)
  const [editLicenseUUID, setEditLicenseUUID] = useState('')
  const [deleteReponse,setDeleteReponse] = useState('')
  const [handleUpdatePopup, setHandleUpdatePopup] = useState(false)
  const [updateLicenseResponse, setUpdateLicenseResponse] = useState('')
  const [updateLicenseSuccess, setUpdateLicenseSuccess] = useState(false)
  const [deleteLicenseSuccess, setDeleteLicenseSuccess] = useState(false)
  const [createNewLicenseSuccess, setCreateNewLicenseSuccess] = useState(false)

  useEffect(() => {
    const checkDefaultData = async () => {
      try {
        const Response = AuthService.get_default_data()
          .then(async (res) => {
            if (res.status === 200 || res.status === 201) {
              let data = await res.json()
              setSubscriptions(data.subscriptions)
              setLicenseTypes(data.license_types)
              console.log(data)
            } else {
              console.log(res)
            }
            
          })
        } catch (error) {
            console.error('An error occurred:', error);
      };
    };  
    checkDefaultData();
  }, []);

  useEffect(() => {
    const getAllLicenseData = async () => {
      try {
        const Response = AuthService.get_all_licenses({
          page: allLicenseDataCurrentPage,
          per_page: 10
        })
          .then(async (res) => {
            if (res.status === 200 || res.status === 201) {
              let data = await res.json()
              setAllLicenseData(data.data)
              setAllLicenseDataCurrentPage(data.current_page)
              setAllLicenseDataTotalPages(data.pages)
            } else {
              console.log(res)
            }
          })
        } catch (error) {
            console.error('An error occurred:', error);
      };
    };  
    getAllLicenseData();
  }, [allLicenseDataCurrentPage]);

  const selectedLicenseTableKeys = ["Lizenz Key", "Subscription Plan","Verfallsdatum"]
 
  const handleAddLicenseClick = () => {
    setIsAddLicenseOpen(true)
  }

  const handleCloseClick = async () => {
    setHandleUpdatePopup(false)
    setHandleDeletePopup(false)
    setNewLicenseKey('')
    setIsDemo('')
    setSelectedSubsUUID('')
    setIsAddLicenseOpen(false);
    setUpdateLicenseResponse('');
    setDeleteReponse('')
    setCreateNewLicenseSuccess(false);
    window.location.reload();
  };

  const handleSelectedPlan = (input_subscription_code) => {
    const subscription = subscriptions.find((subscription)=>subscription.code === input_subscription_code)
    const subscriptionUUID = subscription ? subscription.uuid : null
    setSelectedSubsUUID(subscriptionUUID)
  };

  const handleLicenseType = (input_license_type_code) => {
    const licenseType = licenseTypes.find((licenseType)=>licenseType.code === input_license_type_code)
    const licenseUUID = licenseType ? licenseType.uuid : null
    setSelectedLicenseTypeUUID(licenseUUID)
    
  };

  const handleAddLicenseSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      key: adminKey,
      subscription_uuid: selectedSubsUUID,
      license_type_uuid: selectedLicenseTypeUUID
    }
    console.log(payload)
    try {
      const Response = AuthService.add_new_license(payload)
        .then(async (res) => {
          if (res.status === 200 || res.status === 201) {
            let data = await res.json();
            setNewLicenseKey(data.license_key)
            setCreateNewLicenseSuccess(true)
          } else {
            console.error("Error in response:", res.status, res.statusText);
            alert("Failed to create the user. Please try again.");
          }
          
        })
      } catch (error) {
          console.error('An error occurred:', error);
    };
  };

  const handleDelete = (uuid) => {
    setDeleteLicenseSuccess(false)
    setEditLicenseUUID(uuid)
    setHandleDeletePopup(true)
  };

  const handleLicenseDeleteSubmit = async (e) => {
    e.preventDefault();
    const Response = AuthService.delete_license({
      license_uuid: editLicenseUUID
    })
      .then(async(res) => {
        if (res.status === 200 || res.status === 201) {
          setEditLicenseUUID('')
          setDeleteReponse('Lizenz gelöscht')
          setDeleteLicenseSuccess(true)
        } else {
          console.error("Error in response:", res.status, res.statusText);
          alert("Failed to create the user. Please try again.");
        }
      })
  }

  const handleLicenseUpdateSubmit = async (e) => {
    e.preventDefault();
    const payload = {
      key: adminKey,
      license_uuid: editLicenseUUID,
      subscription_uuid: selectedSubsUUID
    }
    try {
      const Response = AuthService.update_license(payload)
        .then(async (res) => {
          if (res.status === 200 || res.status === 201) {
            let data = await res.json();
            setUpdateLicenseResponse(`${data.subscription.name} ist für ${data.license_key} aktualsiert`)
            setUpdateLicenseSuccess(true)
          } else {
            console.error("Error in response:", res.status, res.statusText);
            alert("Failed to create the user. Please try again.");
          }
          
        })
      } catch (error) {
          console.error('An error occurred:', error);
    };
  }

  // Handler for updating a user (stub for now)
  const handleUpdate = (uuid) => {
    setUpdateLicenseSuccess(false)
    setEditLicenseUUID(uuid)
    setHandleUpdatePopup(true)
  };

  return (
    <div className='container'>
    <div className="main-container">
      <header className="header"> 
        <h1 className='title'></h1>
        <button className='add-button' onClick={handleAddLicenseClick}> + Neue Lizenz </button>
      </header>
      {isAddLicenseOpen && (
        <div className="popup">
        <div className="popup-content">
          <span className="close" onClick={handleCloseClick}>&times;</span>
          {createNewLicenseSuccess && newLicenseKey && (
            <div className="popup-message">
              Bitte notieren Sie den neuen Lizenzschlüssel: {newLicenseKey}
            </div>
          )}
          {!createNewLicenseSuccess && (
            <div>
              <h2 className="popup-title">Bitte Ausfüllen</h2>
              <form onSubmit={handleAddLicenseSubmit} className="popup-form">
                <label htmlFor="admin-key" className="popup-label">
                  Admin Key:
                  <input
                    id="admin-key"
                    type="text"
                    className="popup-input"
                    value={adminKey}
                    onChange={(e) => setAdminKey(e.target.value)}
                    placeholder="Geben Sie den Admin Key ein"
                  />
                </label>
      
                <label htmlFor="duration-select" className="popup-label">
                  Zeitlauf:
                  <select
                    id="duration-select"
                    className="popup-select"
                    onChange={(e) => handleLicenseType(e.target.value)}
                  >
                    <option value="">
                      Zeitlauf auswählen
                    </option>
                    <option value="demo">1 Monat</option>
                    <option value="halfyearly">6 Monate</option>
                    <option value="yearly">1 Jahr</option>
                    {/* <option value="pilotphase">Pilotphase</option> */}
                  </select>
                </label>
      
                <label htmlFor="role-select" className="popup-label">
                  Abonnement Plan:
                  <select
                    id="role-select"
                    className="popup-select"
                    onChange={(e) => handleSelectedPlan(e.target.value)}
                  >
                    <option value="">
                      Plan auswählen
                    </option>
                    <option value="plan1">100</option>
                    <option value="plan2">101-200</option>
                    <option value="plan3">201-301</option>
                    <option value="plan4">301-400</option>
                    <option value="plan5">401-500</option>
                    <option value="plan6">501-750</option>
                    <option value="plan7">751-1000</option>
                    <option value="plan8">1001-1500</option>
                    <option value="plan9">1501-2000</option>
                    <option value="plan10">2001-3000</option>
                    <option value="plan11">3001-4000</option>
                    <option value="plan12">4001-5000</option>
                    <option value="plan13">5001-6000</option>
                    <option value="plan14">6000+</option>
                  </select>
                </label>
      
                <button type="submit" className="popup-submit-button">
                  Lizenz hinzufügen
                </button>
              </form>
            </div>
          )}
          </div>
        </div>
      )}
      {allLicenseData && (
      <div>
        <h2 className='results-title'>Alle Lizenzen</h2>    
        <div className='all-results-table'>
          <table className='table'>
            <thead>
              <tr>
                {selectedLicenseTableKeys.map((key) => (
                  <th key={key}>{key}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {allLicenseData.map((row, index) => (
                <tr key={index}>
                  <td>{row.license_key}</td>
                  <td>{row.subscription.name}</td>
                  <td>{row.date_expiry}</td>
                  <td>
                    <button onClick={() => handleUpdate(row.uuid)}>Update</button>
                    <button onClick={() => handleDelete(row.uuid)}>Delete</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      )}
      {handleDeletePopup && (
        <div className='popup'>
          <div className='popup-content'>
          <span className="close" onClick={handleCloseClick}>
            &times;
            </span>
            <div>{deleteReponse}</div>
            {!deleteLicenseSuccess && (
              <div className={'popup-input-container'}>
                  <div>Sind Sie sicher, dass Sie diesen Lizenzschlüssel löschen möchten?</div>
                  <input className={'popup-submit-button'} type="button" onClick={handleLicenseDeleteSubmit} value={'Löschen'} />
              </div>
            )}  
          </div>
        </div>
      )}
      {handleUpdatePopup && (
        <div className='popup'>
          <div className='popup-content'>
          <span className="close" onClick={handleCloseClick}>
            &times;
            </span>
            <div>{updateLicenseResponse}</div>
            {!updateLicenseSuccess &&(
              <div className={'popup-input-container'}>
                <form onSubmit={handleLicenseUpdateSubmit} className="popup-form">
                  <label htmlFor="admin-key" className="popup-label">
                    Admin Key:
                    <input
                      id="admin-key"
                      type="text"
                      className="popup-input"
                      value={adminKey}
                      onChange={(e) => setAdminKey(e.target.value)}
                      placeholder="Geben Sie den Admin Key ein"
                    />
                  </label>
                  
                  <label htmlFor="role-select" className="popup-label">
                    Abonnement Plan:
                    <select
                      id="role-select"
                      className="popup-select"
                      onChange={(e) => handleSelectedPlan(e.target.value)}
                    >
                      <option value="">
                        Plan auswählen
                      </option>
                      <option value="plan1">100</option>
                      <option value="plan2">101-200</option>
                      <option value="plan3">201-301</option>
                      <option value="plan4">301-400</option>
                      <option value="plan5">401-500</option>
                      <option value="plan6">501-750</option>
                      <option value="plan7">751-1000</option>
                      <option value="plan8">1001-1500</option>
                      <option value="plan9">1501-2000</option>
                      <option value="plan10">2001-3000</option>
                      <option value="plan11">3001-4000</option>
                      <option value="plan12">4001-5000</option>
                      <option value="plan13">5001-6000</option>
                      <option value="plan14">6000+</option>
                    </select>
                  </label>

                  <button type="submit" className="popup-submit-button">
                  Speichern
                  </button>
                </form>
              </div>
            )}  
          </div>
        </div>
      )}
      {/* Pagination Controls */}
      <div className="pagination-container">
        <button
          className="pagination-button"
          onClick={() =>
            setAllLicenseDataCurrentPage((prev) => Math.max(prev - 1, 1))
          }
          disabled={allLicenseDataCurrentPage === 1}
        >
          Previous
        </button>

        {Array.from({ length: allLicenseDataTotalPages }, (_, i) => (
          <button
            key={i + 1}
            className={`pagination-button ${
              allLicenseDataCurrentPage === i + 1 ? "active" : ""
            }`}
            onClick={() => setAllLicenseDataCurrentPage(i + 1)}
          >
            {i + 1}
          </button>
        ))}

        <button
          className="pagination-button"
          onClick={() =>
            setAllLicenseDataCurrentPage((prev) =>
              Math.min(prev + 1, allLicenseDataTotalPages)
            )
          }
          disabled={allLicenseDataCurrentPage === allLicenseDataTotalPages}
        >
          Next
        </button>
      </div>
    </div>    
    </div>
  );
};

export default ManageLicences;